import { GermplasmPairModel } from './germplasm-pair.model';

export class GermplasmPairTraitSearchRequestModel {
    constructor(public testEntryGIDs?: number[],
                public standardEntryGIDs?: number[],
                public germplasmPairs?: GermplasmPairModel[],
                public experimentTypeIds?: number[]
    ) {
    }
}